export default {
  title: 'dark',
  colors: {
    primary: '#bf1363',
    secondary: '#f56476',
    danger: '#ff0000',
    dark: '#1A1423',
    light: '#dfbbb1',
    background: '#222',
    text: '#fff',
    input: {
      color: '#fff',
      background: '#333',
    },
    card: 'rgba(0, 0, 0, 0.75)',
    cardBackground: '#191919',
  },
};
